// Gewerbliche Rollen — Gegenstück zu COMMERCIAL_ROLES im Backend. Sie teilen Firmendaten,
// Lizenz/Verifizierung und das Abo-Gate; nur Preisseite und Dashboard unterscheiden sich.
export const COMMERCIAL_ROLES = ["agent", "developer"];

export const isCommercial = (user) => COMMERCIAL_ROLES.includes(user?.role);

// Single source of truth for "where does this user belong" — used after login/register,
// after the Google OAuth callback, and to keep logged-in users out of /login + /register.
//
// Gewerbliche Konten kommen IMMER ins Dashboard — auch ohne Abo. Bis zum
// 04.08.2026 war die Paketseite eine Zwangsstation („erst 99 € zahlen, dann
// ausprobieren"). Seit dem 01.10.2026 läuft ab Registrierung die Testphase
// (backend services/testphase), und auch danach ist das Dashboard der Ort, an
// dem man sieht, was pausiert ist und wie es weitergeht. Die Paketseiten bleiben als normale Unterseiten
// erreichbar (eigene Zugangsprüfung dort). Der frühere past_due-Sonderfall
// erledigt sich damit von selbst — der Mahn-Banner hängt im Dashboard.
export function roleDestination(user) {
  if (!user || user === false) return "/login";
  if (user.role === "admin") return "/admin";
  if (user.role === "agent") return "/makler-dashboard";
  if (user.role === "developer") return "/developer-dashboard";
  return "/mein-bereich";
}

// Zugangsregel der Paketseiten: richtige Rolle UND noch kein laufendes Abo
// (Aktive/Mahnfälle wechseln ihr Paket im Dashboard-Reiter „Pakete").
export const darfPaketseiteSehen = (user, role) =>
  !!user && user.role === role && !["active", "past_due"].includes(user.subscription_status);

// Ziel des „Inserieren"-Einstiegs (Kopfzeilen-CTA, Kontomenü, untere
// Mobilleiste): Gewerbliche springen direkt in den Assistenten — ihnen die
// Paketseite mit „Kostenlos inserieren" zu zeigen wäre ein falsches
// Versprechen (Nic, 10.08.). Alle anderen (Gast, privat, admin) gehen auf
// /pakete, wo der next=inserat-Flow Registrierung und Slot-Wahl übernimmt.
// Vorher stand diese Regel doppelt inline (Navbar, CreateListing) und das
// Kontomenü sowie die Mobilleiste widersprachen ihr jeweils hart kodiert.
export const inserierenZiel = (user) =>
  (isCommercial(user) ? "/inserat-erstellen" : "/pakete");
